var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgActivated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 179.36 69.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b24aa5c7-6bb0-4f7f-a800-ec9520a10640{fill:#e4ebf8;}.ba6be1db-9d5a-4437-bb8b-5cb71d460436{fill:#fff;}.ab0c16a5-a5e3-4b53-aad8-0992d47eda80{font-size:20px;font-family:SegoeUI-Semilight, Segoe UI;font-weight:300;letter-spacing:-0.01em;}.f668e9ad-bc2c-4836-9a57-5a4d717ae1f0{letter-spacing:-0.02em;}.b8a9b0d7-745f-4963-9d1b-a0b0b161db0d{letter-spacing:-0.01em;}.bdc1979b-44cf-472b-b8aa-e575a84cfc94{fill:#f4364c;}.b09b0dc4-ad5b-4dec-ab80-3c04bde6b99d{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.24px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a9fc71d1-a0fe-464a-ade5-b9ef7058390a",
    "data-name": "Layer 14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b24aa5c7-6bb0-4f7f-a800-ec9520a10640",
    d: "M45,56.59c-13,0-23.48-10.14-23.48-22.61S32.08,11.38,45,11.38H155c13,0,23.48,10.14,23.48,22.6S167.93,56.59,155,56.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ba6be1db-9d5a-4437-bb8b-5cb71d460436",
    d: "M155,12.27c12.45,0,22.59,9.74,22.59,21.71S167.43,55.69,155,55.69H45C32.57,55.69,22.44,46,22.44,34S32.57,12.27,45,12.27H155m0-1.79H45C31.56,10.48,20.65,21,20.65,34S31.56,57.48,45,57.48H155c13.46,0,24.38-10.52,24.38-23.5S168.44,10.48,155,10.48Z"
  }), /*#__PURE__*/React.createElement("text", {
    className: "ab0c16a5-a5e3-4b53-aad8-0992d47eda80",
    transform: "translate(73.65 40.56)"
  }, "Dashb", /*#__PURE__*/React.createElement("tspan", {
    className: "f668e9ad-bc2c-4836-9a57-5a4d717ae1f0",
    x: 53.38,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "b8a9b0d7-745f-4963-9d1b-a0b0b161db0d",
    x: 64.38,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "f668e9ad-bc2c-4836-9a57-5a4d717ae1f0",
    x: 74.2,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "b8a9b0d7-745f-4963-9d1b-a0b0b161db0d",
    x: 80.51,
    y: 0
  }, "d")), /*#__PURE__*/React.createElement("path", {
    className: "bdc1979b-44cf-472b-b8aa-e575a84cfc94",
    d: "M34.55,68.25a5.9,5.9,0,0,1-4.17-1.73L2.73,38.86a5.9,5.9,0,0,1,0-8.34L30.38,2.86a5.93,5.93,0,0,1,8.35,0L66.38,30.52a5.9,5.9,0,0,1,0,8.34L38.73,66.52A5.9,5.9,0,0,1,34.55,68.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ba6be1db-9d5a-4437-bb8b-5cb71d460436",
    d: "M34.55,2.14A4.9,4.9,0,0,1,38,3.57L65.67,31.23a4.91,4.91,0,0,1,0,6.93L38,65.81a4.89,4.89,0,0,1-6.93,0L3.44,38.16a4.89,4.89,0,0,1,0-6.93L31.09,3.57a4.9,4.9,0,0,1,3.46-1.43m0-2a6.84,6.84,0,0,0-4.87,2L2,29.81a6.91,6.91,0,0,0,0,9.76L29.68,67.22a6.87,6.87,0,0,0,9.75,0L67.09,39.57a6.91,6.91,0,0,0,0-9.76L39.43,2.16a6.85,6.85,0,0,0-4.88-2Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ba6be1db-9d5a-4437-bb8b-5cb71d460436",
    x: 24.22,
    y: 24.35,
    width: 20.68,
    height: 20.68,
    rx: 2.77
  }), /*#__PURE__*/React.createElement("path", {
    className: "b09b0dc4-ad5b-4dec-ab80-3c04bde6b99d",
    d: "M24,24.14h0a5.92,5.92,0,0,1,.41.45l1,1.23a5.63,5.63,0,0,0,4.39,2.1h9.26a5.67,5.67,0,0,0,4.05-1.71l1.79-1.86.22-.21a5.64,5.64,0,0,0-4-9.63H28A5.64,5.64,0,0,0,24,24.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b09b0dc4-ad5b-4dec-ab80-3c04bde6b99d",
    d: "M24,45.24h0a5.82,5.82,0,0,1,.45-.4l1.23-1a5.65,5.65,0,0,0,2.11-4.39V30.2a5.62,5.62,0,0,0-1.72-4.05l-1.85-1.8L24,24.14a5.64,5.64,0,0,0-9.63,4V41.26A5.64,5.64,0,0,0,24,45.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b09b0dc4-ad5b-4dec-ab80-3c04bde6b99d",
    d: "M45.11,45.24h0a5.92,5.92,0,0,1-.41-.45l-1-1.23a5.63,5.63,0,0,0-4.39-2.1H30.06a5.62,5.62,0,0,0-4,1.72L24.22,45l-.22.21a5.64,5.64,0,0,0,4,9.63H41.12A5.64,5.64,0,0,0,45.11,45.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b09b0dc4-ad5b-4dec-ab80-3c04bde6b99d",
    d: "M45.11,24.14h0a5.6,5.6,0,0,1-.45.4l-1.23,1a5.65,5.65,0,0,0-2.11,4.4v9.25a5.62,5.62,0,0,0,1.72,4L44.89,45l.22.21a5.63,5.63,0,0,0,9.62-4V28.12A5.63,5.63,0,0,0,45.11,24.14Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "ba6be1db-9d5a-4437-bb8b-5cb71d460436",
    cx: 54.73,
    cy: 34.69,
    r: 3.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "ba6be1db-9d5a-4437-bb8b-5cb71d460436",
    cx: 34.55,
    cy: 14.51,
    r: 3.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "ba6be1db-9d5a-4437-bb8b-5cb71d460436",
    cx: 14.37,
    cy: 34.69,
    r: 3.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "ba6be1db-9d5a-4437-bb8b-5cb71d460436",
    cx: 34.55,
    cy: 54.87,
    r: 3.21
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivated);
export default __webpack_public_path__ + "static/media/activated.3098fa90.svg";
export { ForwardRef as ReactComponent };